import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { DvmService } from '@core/services';
import { BestAvailableService } from '@features/digital-venue/services/best-available.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-best-seats',
  templateUrl: './best-seats.component.html',
  styleUrl: './best-seats.component.scss',
})
export class BestSeatsComponent implements OnInit, OnDestroy {
  // SERVICES
  private dvmService: DvmService = inject(DvmService);
  private bestAvailable: BestAvailableService = inject(BestAvailableService);

  @Input()
  public debugMode: boolean = false;

  @Input()
  public selectedTickets: number;

  @Input()
  public selectedAdasSeats: number;

  // STATE
  public isMapLoading: boolean = true;

  // DVM SUBSCRIPTIONS
  private subscriptions: Subscription[] = [];

  // TEMPLATE
  public templateVars: { text: string; button: string } = {
    text: 'Accessible seats included in ticket total',
    button: 'Add Best Seats',
  };

  // LIFE CYCLE
  public ngOnInit(): void {
    this.initComponent();
  }

  public ngOnDestroy(): void {
    this.destroyComponent();
  }

  // METHODS
  /**
   * BA algorithm can only be executed in the top view.
   * When user enter on section or 3d, disable button
   * @returns
   */
  get shouldEnableBestAvailable(): boolean {
    return (
      this.dvmService.isTopView() &&
      !this.isMapLoading &&
      !this.dvmService.is3dView()
    );
  }

  get tooltipMessage(): string {
    return this.dvmService.isTopView() && this.isMapLoading
      ? 'Wait until the map has loaded'
      : 'Go back and try again on the seat map';
  }

  public addBestSeats(): void {
    if (this.debugMode) {
      console.log('Add Best Seats called');
    }

    const totalSeats: number = this.selectedTickets - this.selectedAdasSeats;

    this.bestAvailable.getBestXSeats(totalSeats, this.selectedAdasSeats);
  }

  private initComponent(): void {
    const subscription = this.dvmService.viewerService
      .waitInitialize()
      .subscribe({
        next: () => {
          this.subscriptions.push(
            this.dvmService.viewerService
              .getObservable('load_success')
              .subscribe(() => {
                this.isMapLoading = false;
              })
          );
        },
      });
    this.subscriptions.push(subscription);
  }

  private destroyComponent(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
